import { Component, Input, OnInit } from "@angular/core";

import { RolesService } from "src/app/core/api/services";
import { AppRoleSelectionListInputType } from "src/app/core/types/app-role-selection-list-input-type.type";
import { BaseSelectionList } from "../base/base-selection-list.component";

@Component({
    selector: "role-selection-list",
    templateUrl: "./role-selection-list.component.html",
    standalone: false
})
export class RoleSelectionList extends BaseSelectionList implements OnInit {
  @Input("type") input_type: AppRoleSelectionListInputType = "roles";

  constructor(protected currentService: RolesService) {
    super();
  }

  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  initConfig() {
    this.optionValue = "key";
    this.optionTitle = "value";
    this.sortKey = "key";

    if (!this.input_label) this.input_label = "common.group";
  }

  getItems() {
    if (this.loading) return;

    this.loading = true;

    switch (this.input_type) {
      case "roles":
        this.currentService
          .rolesGetRoles()
          .pipe(this.baseSelectionSearchPipeOperators)
          .subscribe((items) => {
            this.items = items;
          });
        break;

      case "organizationRoles":
        if (!this.id) {
          this.loading = false;
          return;
        }

        this.currentService
          .rolesGetRoles2({ organizationId: +this.id })
          .pipe(this.baseSelectionSearchPipeOperators)
          .subscribe((items) => {
            this.items = items?.data;
          });
        break;
    }
  }
}
